import { model } from "core/util";
import { PensionDdsActiveOperations as PensionDdsActiveOperationsType, PensionDdsActiveOperationsDto } from "types";

export const PensionDdsActiveOperations = model.createModel<PensionDdsActiveOperationsDto, PensionDdsActiveOperationsType>((json) => ({
    isSet: json.IsSet,
    phone: json.Phone,
    dateTime: json.DateTime,
}));
